export default "__VITE_ASSET__Cnn00Ced__"